const {
    tastehubProductConstants,
    tastehubRecipeConstants,
    tastehubNutritionLabels,
} = require("../constants/tastehub.constants")

const getProductNutrition = product => {
    let nutritionInformation = {}

    function getNutritionLabel(nutritionName) {
        const name = nutritionName
            // Remove number and space at the start
            .replace(/^\d+\s*/, "")
            // Remove anything in parentheses
            .replace(/\(.*\)/, "")
            .trim()
            .toLowerCase()

        return tastehubNutritionLabels[name] || null
    }

    if (Array.isArray(product?.nutritions)) {
        nutritionInformation = {
            serving: product?.nutritions
                ?.filter(item => item.nutrition_set_type_xml_tag === "serving")
                .map(item => ({
                    nutrition_name: item.nutrition_name,
                    unit_name: item.unit_name,
                    value: item.value,
                    nutrition_label: getNutritionLabel(item.nutrition_name),
                })),
            weight: product?.nutritions
                ?.filter(item => item.nutrition_set_type_xml_tag === "weight")
                .map(item => ({
                    nutrition_name: item.nutrition_name,
                    nutrition_label: getNutritionLabel(item.nutrition_name),
                    value: item.value,
                    unit_name: item.unit_name,
                })),
        }
    }
    return nutritionInformation
}

const getProductTexts = product => {
    const texts = {}

    if (Array.isArray(product?.texts)) {
        product?.texts?.forEach(item => {
            const xmlTag = item["text_type"]["xml_tag"]
            switch (xmlTag) {
                case tastehubProductConstants.text.name:
                    texts.name = item.text
                    break
                case tastehubProductConstants.text.dietary:
                    texts.dietary = item.text
                    break
                case tastehubProductConstants.text.moodText:
                    texts.moodText = item.text
                    break
                case tastehubProductConstants.text.ingredients:
                    texts.ingredients = item.text
                    break
                case tastehubProductConstants.text.productName:
                    texts.productName = item.text
                    break
                case tastehubProductConstants.text.cuc:
                    texts.cuc = item.text
                    break
                case tastehubProductConstants.text.tuc:
                    texts.tuc = item.text
                    break
                case tastehubProductConstants.text.sku:
                    texts.sku = item.text
                    break
                case tastehubProductConstants.text.usageConditions:
                    texts.usageConditions = item.text
                    break
                case tastehubProductConstants.text.allergens:
                    texts.allergens = item.text
                    break
                default:
                    break
            }
        })
    }
    return texts
}

const getProductImages = product => {
    const images = {}
    for (const key in tastehubProductConstants.image) {
        images[key] = null
    }
    if (Array.isArray(product?.images)) {
        product?.images?.forEach(item => {
            const xmlTag = item["image_type"]["xml_tag"]
            const imageDetails = {
                url: item.image_url,
                width: item.image_type.width,
                height: item.image_type.height,
            }
            for (const key in tastehubProductConstants.image) {
                if (tastehubProductConstants.image[key] === xmlTag) {
                    images[key] = imageDetails
                    break
                }
            }
        })
    }
    return images
}

const getRecipeMedia = recipe => {
    const images = {
        main: null,
        detailPage: null,
    }
    if (Array.isArray(recipe?.images)) {
        recipe?.images?.forEach(item => {
            const imageDetails = {
                url: item.image_url,
                width: item.image_type.width,
                height: item.image_type.height,
            }
            if (item.image_type.id === tastehubRecipeConstants.image.main) {
                images.main = imageDetails
            }
            if (item.image_type.id === tastehubRecipeConstants.image.detailPage) {
                images.detailPage = imageDetails
            }
        })
    }
    return images
}

const getRecipeNutrition = recipe => {
    if (!recipe || !recipe.portions || recipe.portions <= 0) return {}

    function convertKilojoulesToKilocalories(kj) {
        const KJ_TO_KCAL = 0.239005736;
        return parseFloat((kj * KJ_TO_KCAL).toFixed(1));
    }
    const addUnits = (key, value) => {
        const roundedValue = Number(value.toFixed(1))
        if(key === "kJ/Kcal") {
            return `${roundedValue} kJ / ${convertKilojoulesToKilocalories(roundedValue)} kcal`
        } else return `${roundedValue}g`
    }

    const nutritionKeys = {
        Calcium: "nutr_calcium",
        Carbs: "nutr_carb",
        Cholesterol: "nutr_cholesterol",
        "Dietary Fibre": "nutr_dietary_fibre",
        Fat: "nutr_fat",
        Iron: "nutr_iron",
        "kJ/Kcal": "nutr_kj",
        Protein: "nutr_protein",
        "Saturated Fat": "nutr_sat_fat",
        Sodium: "nutr_sodium",
        Sugars: "nutr_sugars",
        "Vitamin A": "nutr_vit_a",
        "Vitamin C": "nutr_vit_c",
    }

    const nutritions = Object.fromEntries(
        Object.entries(nutritionKeys).map(([label, key]) => {
            const value = recipe[key] / recipe.portions
            const modifiedValue = value && !isNaN(value) ? addUnits(label, value ) : null
            return [label, modifiedValue]
        })
    )

    return nutritions
}

module.exports = {
    getProductTexts,
    getProductImages,
    getRecipeMedia,
    getProductNutrition,
    getRecipeNutrition,
}
